module.exports = __webpack_public_path__ + "files/b4a7b20c27910e1ebbe4b3a870e1bd2d.png";